import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserService } from '../../../../services/user.service';
import { AdministrationService } from '../../../../services/administration.service';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar, MatDialog } from '@angular/material';
// import { WMSValidators } from '../../../../shared/validators';
import { AddNewAccountOfficeOtherGovernmentDialog } from './dialog.addnewaccoffice';
import { EditAccountOfficeOtherGovernmentDialog } from './dialog.editaccoffice';


@Component({
  selector: 'app-other-government',
  templateUrl: './other-government.component.html',
  styleUrls: ['./other-government.component.css']
})
export class AccountOfficeOtherGovernmentComponent implements OnInit, OnDestroy {
  allSub: Subscription[] = [];
  accOffListform: FormGroup;
  warrantAuthCode: string = 'OT';
  errorMessage: string = '';
  isLoading: boolean = false;
  userName: string = '';
  screenCode: string = '';

  p: number = 1;
  datasource: any[];
  totalCount: number = 0;

  constructor(private userService: UserService,
    private administrationService: AdministrationService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog) {
    let user = this.userService.getUser();
    this.userName = user.username;
    this.screenCode = user.screenCode;
  }

  ngOnInit() {
    this.accOffListform = new FormGroup({
      accOffCode: new FormControl({ value: '', disabled: false }, [Validators.maxLength(32767)]),
      accOff: new FormControl({ value: '', disabled: false }, [Validators.maxLength(32767)]),
    });

    let getAccOff = {
      Page: this.p,
      AccOffCode: '',
      AccOff: '',
      MailTo: '',
      MailCc: '',
      MailBcc: ''
    };
    this.isLoading = true;

    let init_sub = this.administrationService.getOthAccountOfficeList(getAccOff)
      .subscribe(
        (value) => {
          this.isLoading = false;
          if (value.status === 204) {

          } else if (value.status === 200) {
            this.datasource = value.body['accountOffices'];
            this.totalCount = value.body['totalCount'];
            this.p = 1;
          } else {
            this.openSnackBar('Error retrieving account office list.', '');
          }
        },
        (error) => {
          this.isLoading = false;
          this.errorMessage = <any>error;
          this.openSnackBar(this.errorMessage, '');
        });

    //Adds into array for each subscribe
    this.allSub.push(init_sub);
  }

  addNewAccOffice() {
    let dialogRef = this.dialog.open(AddNewAccountOfficeOtherGovernmentDialog, {
      width: '60%',
      disableClose: true,
      data: {
        warrantauthcode: this.warrantAuthCode
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Add new successful') {
        this.nextPage(1);
        this.openSnackBar('New Account Office Added', '');
      }
    });
  }

  search(form: FormGroup) {
    let getAccOff = {
      Page: 1,
      AccOffCode: form['accOffCode'],
      AccOff: form['accOff'],
      MailTo: '',
      MailCc: '',
      MailBcc: ''
    };
    this.isLoading = true;

    let search_sub = this.administrationService.getOthAccountOfficeList(getAccOff)
      .subscribe(
        (value) => {
          this.isLoading = false;
          if (value.status === 204) {

          } else if (value.status === 200) {
            this.p = 1;
            this.datasource = value.body['accountOffices'];
            this.totalCount = value.body['totalCount'];
          } else {
            this.openSnackBar('Error retrieving account office list.', '');
          }
        },
        (error) => {
          this.isLoading = false;
          this.errorMessage = <any>error;
          this.openSnackBar(this.errorMessage, '');
        });

    //Adds into array for each subscribe
    this.allSub.push(search_sub);
  }

  nextPage(page: number) {
    this.isLoading = true;
    let getAccOff = {
      Page: page,
      AccOffCode: this.accOffListform.get('accOffCode')!.value,
      AccOff: this.accOffListform.get('accOff')!.value,
      MailTo: '',
      MailCc: '',
      MailBcc: ''
    };

    let nextpage_sub = this.administrationService.getOthAccountOfficeList(getAccOff)
      .subscribe(
        (value) => {
          this.isLoading = false;
          if (value.status === 204) {

          } else if (value.status === 200) {
            this.p = page;
            this.datasource = value.body['accountOffices'];
            this.totalCount = value.body['totalCount'];
          } else {
            this.openSnackBar('Error retrieving account office list.', '');
          }
        },
        (error) => {
          this.isLoading = false;
          this.errorMessage = <any>error;
          this.openSnackBar(this.errorMessage, '');
        });

    //Adds into array for each subscribe
    this.allSub.push(nextpage_sub);
  }

  openEditAccDialog(accOffCode: string, accOff: string) {
    let dialogRef = this.dialog.open(EditAccountOfficeOtherGovernmentDialog, {
      width: '60%',
      disableClose: true,
      data: {
        warrantauthcode: this.warrantAuthCode,
        accoffcode: accOffCode,
        accoff: accOff
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Edit successful') {
        this.nextPage(1);
        this.openSnackBar('Change(s) Saved', '');
      }
    });
  }

  deleteAcc(accOffCode: string) {
    let cfm = confirm("Are you sure you want to delete the selected Account Office?");

    if (cfm) {
      this.isLoading = true;

      let accountOfficeDetail = {
        WarrantAuthCode: this.warrantAuthCode,
        AccOffCode: accOffCode,
        AccOff: '',
        MailTo: '',
        MailCc: '',
        MailBcc: ''
      }

      let save_sub = this.administrationService.othDeleteAccOff(accountOfficeDetail)
        .subscribe(
          (value) => {
            if (value.status === 204) {

            } else if (value.status === 200) {
              this.isLoading = false;
              this.openSnackBar(value.body ? value.body.toString() : '', '');
              this.nextPage(1);
            } else {

            }
          },
          (error) => {
            this.errorMessage = <any>error;
            this.openSnackBar(this.errorMessage, '');
          });

      //Adds into array for each subscribe
      this.allSub.push(save_sub);
    } else {
      this.isLoading = false;
    }
  }

  ngOnDestroy() {
    for (let sub of this.allSub) {
      sub.unsubscribe();
    }
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }
}
